import React from 'react';
import { GroupGeofenceMode, useGroupGeofencePageContext, } from '../../GroupGeofencePage.context';
import { Button } from 'antd';
import MaximizeIcon from './MaximizeIcon';
var CreateBoundary = function () {
    var _a, _b;
    var context = useGroupGeofencePageContext();
    if (((_b = (_a = context.selectedGeofence) === null || _a === void 0 ? void 0 : _a.geofence) === null || _b === void 0 ? void 0 : _b.length) !== 0 || context.mode) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { style: {
            display: 'flex',
            alignItems: 'center',
            background: '#E65F38',
            height: 46,
            position: 'absolute',
            top: 4,
            left: 4,
            right: 0,
            zIndex: 100,
            width: 'calc(100% - 8px)',
            padding: '0 9px',
        } },
        React.createElement("div", { style: {
                marginRight: 16,
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
            } },
            React.createElement(MaximizeIcon, null),
            React.createElement("h4", { style: {
                    fontSize: 16,
                    color: '#ffffff',
                    lineHeight: '22px',
                    fontWeight: 600,
                } }, "Draw on the map to set a new geofence")),
        React.createElement(Button, { onClick: function () {
                context.setMode(GroupGeofenceMode.Geofence);
            } }, "Create Boundary")));
};
export default CreateBoundary;
